import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      Authorization: `Bearer ${token}`
    }
  };
};

// Auth
export const login = (data) => axios.post(`${API}/auth/login`, data);
export const register = (data) => axios.post(`${API}/auth/register`, data);
export const getMe = () => axios.get(`${API}/auth/me`, getAuthHeaders());

// Companies
export const getCompanies = () => axios.get(`${API}/companies`, getAuthHeaders());
export const createCompany = (data) => axios.post(`${API}/companies`, data, getAuthHeaders());
export const updateCompany = (id, data) => axios.put(`${API}/companies/${id}`, data, getAuthHeaders());
export const deleteCompany = (id) => axios.delete(`${API}/companies/${id}`, getAuthHeaders());

// Banks
export const getBanks = (companyId) => {
  const url = companyId ? `${API}/banks?company_id=${companyId}` : `${API}/banks`;
  return axios.get(url, getAuthHeaders());
};
export const createBank = (data) => axios.post(`${API}/banks`, data, getAuthHeaders());
export const updateBank = (id, data) => axios.put(`${API}/banks/${id}`, data, getAuthHeaders());
export const deleteBank = (id) => axios.delete(`${API}/banks/${id}`, getAuthHeaders());

// Expected Receipts
export const getExpectedReceipts = (companyId) => {
  const url = companyId ? `${API}/expected-receipts?company_id=${companyId}` : `${API}/expected-receipts`;
  return axios.get(url, getAuthHeaders());
};
export const createExpectedReceipt = (data) => axios.post(`${API}/expected-receipts`, data, getAuthHeaders());
export const updateExpectedReceipt = (id, data) => axios.put(`${API}/expected-receipts/${id}`, data, getAuthHeaders());
export const clearExpectedReceipt = (id) => axios.patch(`${API}/expected-receipts/${id}/clear`, {}, getAuthHeaders());
export const deleteExpectedReceipt = (id) => axios.delete(`${API}/expected-receipts/${id}`, getAuthHeaders());

// Payments
export const getPayments = (companyId) => {
  const url = companyId ? `${API}/payments?company_id=${companyId}` : `${API}/payments`;
  return axios.get(url, getAuthHeaders());
};
export const createPayment = (data) => axios.post(`${API}/payments`, data, getAuthHeaders());
export const updatePayment = (id, data) => axios.put(`${API}/payments/${id}`, data, getAuthHeaders());
export const markPaymentPaid = (id) => axios.patch(`${API}/payments/${id}/pay`, {}, getAuthHeaders());
export const deletePayment = (id) => axios.delete(`${API}/payments/${id}`, getAuthHeaders());

// Security Cheques
export const getSecurityCheques = (companyId) => {
  const url = companyId ? `${API}/security-cheques?company_id=${companyId}` : `${API}/security-cheques`;
  return axios.get(url, getAuthHeaders());
};
export const createSecurityCheque = (data) => axios.post(`${API}/security-cheques`, data, getAuthHeaders());
export const deleteSecurityCheque = (id) => axios.delete(`${API}/security-cheques/${id}`, getAuthHeaders());

// Market Data
export const getMarketData = () => axios.get(`${API}/market/live`, getAuthHeaders());

// Dashboard
export const getDashboardSummary = () => axios.get(`${API}/dashboard/summary`, getAuthHeaders());

// Audit Logs
export const getAuditLogs = () => axios.get(`${API}/audit-logs`, getAuthHeaders());